import React, {Component} from 'react'
import ga from 'react-ga'

import InstantBookingStore from 'stores/InstantBookingStore'
import CategoryStore from 'stores/CategoryStore'
import UserStore from 'stores/UserStore'

import ActionCreators from 'actions/ActionCreators'

import {createControlFactory} from 'components/Controls'
import RestorePasswordDialog from 'components/RestorePasswordDialog'
import InstantBookingHow from 'components/InstantBookingHow'
import InstantBookingWhy from 'components/InstantBookingWhy'
import InstantBookingQa from 'components/InstantBookingQa'
import ButtonControl from 'components/ButtonControl'

import {INSTANT_PRICES_TYPE_NAMES} from '../../constants/Instantprices'
import {translate as t} from 'lang'
import {dumpState, saveInstantBookingEmail} from 'api'

import TelControl from 'components/TelControl';

import './InstantBookingContactsScreen.scss'

function getStateFromStores() {
    return {
        price: InstantBookingStore.getPrice(),
        selectedCategory: CategoryStore.getSelected(),
        user: UserStore.getUser(),
        type: InstantBookingStore.getType(),
        selectedPaymentType: InstantBookingStore.getSelectedPaymentTypeName(),
        userHasToken: UserStore.hasToken(),
        userHasVVauthorization: UserStore.hasVVauthorization(),
    }
}

class InstantBookingContactsScreen extends Component {

    constructor(props) {
        super(props)
        const storeStates = getStateFromStores()

        this.state = {
            ...storeStates,
            showRestorePasswordDialog: false,
            isPhoneOrMail: false,
            phoneAuth: '',
            phoneErrors: '',
        }

        this.Control = createControlFactory(ActionCreators.updateUser)
    }

    componentDidMount() {
        InstantBookingStore.addChangeListener(this._onChange)
        UserStore.addChangeListener(this._onChange)

        ActionCreators.cancelTankmenValidation()

        if (this.state.userHasToken || this.state.userHasVVauthorization) {
            ActionCreators.updateUser({
                has_account: true,
            })
        }
    }

    componentWillUnmount() {
        InstantBookingStore.removeChangeListener(this._onChange)
        UserStore.removeChangeListener(this._onChange)
    }

    _onChange = () => {
        this.setState(getStateFromStores())
    }

    _pushErrorsToGa = (error) => {
        let prefix = 'noreg'
        if (this.state.user.has_account.value) {
            prefix = 'reg'
        }

        for (let name in error) {
            ga.event({
                category: 'fields',
                action: `booking_wrong_${name}_${prefix}`,
                label: this.state.selectedCategory.name,
                value: 1,
            })
        }
    }

    _onChangeHasAccount = () => {
        ga.event({
            category: 'clicks',
            action: this.state.user.has_account.value ? 'registered' : 'non-registered',
            label: this.state.selectedCategory.name,
            value: 1,
        });

        ActionCreators.updateUser({
            isPhoneOrMail: false
        });
    }

    _onBlurNameInput = (event) => {
        let prefix = ''
        if (this.state.user.has_account.value) {
            prefix = 'reg_'
        }

        if (event.target.value) {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}fill_name`,
                label: this.state.selectedCategory.name,
                value: 1,
            })
        } else {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}empty_name`,
                label: this.state.selectedCategory.name,
                value: 1,
            })
        }
    }

    _onBlurEmailInput = (event) => {
        let prefix = ''
        if (this.state.user.has_account.value) {
            prefix = 'reg_'
        }

        if (event.target.value) {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}fill_email`,
                label: this.state.selectedCategory.name,
                value: 1,
            })
        } else {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}empty_email`,
                label: this.state.selectedCategory.name,
                value: 1,
            })
        }
    }

    _onBlurPasswordInput = (event) => {
        let prefix = ''
        if (this.state.user.has_account.value) {
            prefix = 'reg_'
        }

        if (event.target.value) {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}fill_password`,
                label: this.state.selectedCategory.name,
                value: 1,
            })
        } else {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}empty_password`,
                label: this.state.selectedCategory.name,
                value: 1,
            })
        }
    }

    _onBlurMobilePhoneInput = (phone) => {
        console.log(phone);
        let prefix = ''
        if (this.state.user.has_account.value) {
            prefix = 'reg_'
        }

        let _phone = phone.replace(/[\-\s]/g, '')

        if (_phone && _phone.length > 5) {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}fill_mobile`,
                label: this.state.selectedCategory.name,
                value: 1,
            })
        } else {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}empty_mobile`,
                label: this.state.selectedCategory.name,
                value: 1,
            })
        }
    }

    _onClickForgotPass = () => {
        this.setState({
            showRestorePasswordDialog: true,
        })

        ga.event({
            category: 'clicks',
            action: 'click_forgot_pass_booking_step_5',
            label: this.props.selectedCategory.name,
            value: 1,
        })
    }

    _toggleIsPhoneOrMail = () => {
        this.setState({
            isPhoneOrMail: !this.state.isPhoneOrMail,
        });
    }

    _onChangePhoneAuth = (e, phoneAuth) => {
        this.setState({ phoneAuth });

        ActionCreators.updateUser({
            phone_mobile: phoneAuth,
        });
    }

    _onCloseRestorePasswordDialog = () => {
        this.setState({
            showRestorePasswordDialog: false,
        })

        ActionCreators.setAutologinHash(undefined)
    }

    _onRestorePasswordComplete = (autologinHash) => {
        ActionCreators.setAutologinHash(autologinHash)
        this._onSubmit()
    }

    _onSubmit = (e) => {
        if (e) {
            e.preventDefault()
        }

        ga.event({
            category: 'instant_booking_orders',
            action: 'add_orders_book_s5_from_instant_booking',
            label: this.state.selectedCategory.name,
            value: 1,
        })

        if (window.ym) {
            window.ym('1315865', 'reachGoal', 'add_orders_book_s5_from_instant_booking');
        }

        ActionCreators.showLoadingOverlay()

        if (this.state.user.has_account.value) {
            if (this.state.isPhoneOrMail) {
                ActionCreators.updateUser({
                    email: '',
                });
            } else {
                ActionCreators.updateUser({
                    phone_mobile: '',
                });
            }
        }

        // call submit action
        UserStore
        .validate()
        .then(() => {
            ActionCreators.sendUserToGa()
            saveInstantBookingEmail(this.state.user.email.value)

            UserStore
            .submit()
            .then(response => {
                ga.event({
                    category: 'clicks',
                    action: 'button_ship_cost',
                    label: this.state.selectedCategory.name,
                    value: 1,
                })

                ga.event({
                    category: 'orders',
                    action: `instant_booking_${INSTANT_PRICES_TYPE_NAMES[this.state.type]}`,
                    label: this.state.selectedCategory.name,
                    value: this.state.price,
                })

                if (window.ym) {
                    window.ym('1315865', 'reachGoal', `instant_booking_${INSTANT_PRICES_TYPE_NAMES[this.state.type]}`);
                    window.ym('1315865', 'reachGoal', 'instant_booking_new_order', {
                        calendar_uid: response.uid,
                        calendar_order_id: response.oid,
                        order_price: parseInt(this.state.price, 10),
                        currency: "RUB",
                    });
                    window.ym('1315865', 'reachGoal', 'add_load', {
                        uid: response.uid,
                        order_id: response.oid,
                    });
                }

                // In widget mode
                if (window.parent) {
                    window.parent.location.href = response.redirect_url
                } else {
                    window.location.href = response.redirect_url
                }
            }, (error) => {
                ActionCreators.hideLoadingOverlay()

                // Clear autologin hash, because It could be set for email, that shall not pass the validation.
                // For example carrier's email.
                if (UserStore.hasAutologinHash()) {
                    ActionCreators.setAutologinHash(undefined)
                }

                if (!error) {
                    dumpState()
                    alert(t('SOMETHING_WENT_WRONG'))
                } else {
                    if (error.price) {
                        alert(t(error.price))
                    } else {
                        alert(t('SOMETHING_WENT_WRONG'))
                    }
                }
            })
        }, (error) => {
            if (error.phone_mobile) {
                this.setState({ phoneErrors: error.phone_mobile })
            }

            ActionCreators.hideLoadingOverlay()
            this._pushErrorsToGa(error)
        })
    }

    renderContactsForm = () => {
        if (this.state.userHasToken || this.state.userHasVVauthorization) {
            return null
        }

        const hasAccount = this.state.user.has_account.value

        const user = this.state.user

        return (
            <div>
                <this.Control
                    type="switch"
                    onChange={this._onChangeHasAccount}
                    attribute={user.has_account}
                    checked={hasAccount}
                    size="m"
                    label="Я уже зарегистрирован на «Везёт Всем»"
                />

                {hasAccount &&
                    <div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            marginTop: '20px',
                        }}>
                            <span>Авторизация по почте</span>
                            <this.Control
                                type="switch"
                                attribute={user.isPhoneOrMail}
                                checked={this.state.isPhoneOrMail}
                                onChange={this._toggleIsPhoneOrMail}
                                size="m"
                                label=""
                            />
                            <span>Авторизация по номеру</span>
                        </div>
                        <div style={{width: '560px'}} className="InstantBookingContactsScreen-submitForm-fields">
                            <div className="InstantBookingContactsScreen-submitForm-field">
                                {
                                    this.state.isPhoneOrMail
                                            ? (
                                                <TelControl
                                                    required
                                                    onChange={this._onChangePhoneAuth}
                                                    value={this.state.phoneAuth}
                                                    label={'Телефон грузоотправителя'}
                                                    placeholder={'Телефон грузоотправителя'}
                                                    error={this.state.phoneErrors}
                                                />
                                            )
                                            : (
                                                <this.Control
                                                    id="hasAccountEmail"
                                                    type="text"
                                                    attribute={user.email}
                                                    name="email"
                                                    required
                                                    onBlur={this._onBlurEmailInput}
                                                    placeholder="Электронная почта"
                                                    label="Электронная почта"
                                                    htmlType="email"
                                                />
                                            )
                                    }
                                </div>
                                <div className="InstantBookingContactsScreen-submitForm-field">
                                    <this.Control
                                        required
                                        id="hasAccountPass"
                                        type="text"
                                        htmlType="password"
                                        attribute={user.password}
                                        name="password"
                                        onBlur={this._onBlurPasswordInput}
                                        label="Пароль"/>
                                    <div className="ContactsScreen-contactsForgotPassBox">
                                        <a
                                            className="ContactsScreen-contactsForgotPass"
                                            href="javascript:;"
                                            onClick={this._onClickForgotPass}>
                                            Я забыл пароль
                                        </a>
                                    </div>
                                </div>
                            </div>
                    </div>
                }
                {!hasAccount &&
                    <div className="InstantBookingContactsScreen-submitForm-fields">
                        <div className="InstantBookingContactsScreen-submitForm-field">
                            <this.Control
                                type="text"
                                attribute={user.name}
                                name="name"
                                required
                                placeholder="Фамилия Имя"
                                onBlur={this._onBlurNameInput}
                                label="Имя грузоотправителя"/>
                        </div>

                        <div className="InstantBookingContactsScreen-submitForm-field">
                            <this.Control
                                id="hasNoAccountPassEmail"
                                type="text"
                                attribute={user.email}
                                name="email"
                                required
                                onBlur={this._onBlurEmailInput}
                                onChange={(e, email) => this.setState({email})}
                                value={this.state.email}
                                placeholder="email@example.com"
                                label="Электронный адрес"
                                htmlType="email"/>
                        </div>

                        <div className="InstantBookingContactsScreen-submitForm-field">
                            <this.Control
                                required
                                type="tel"
                                attribute={user.phone_mobile}
                                name="phone_mobile"
                                onBlur={this._onBlurMobilePhoneInput}
                                onChange={(e, phone) => this.setState({phone})}
                                value={this.state.phone}
                                label="Телефон грузоотправителя"
                            />
                        </div>
                    </div>
                }
            </div>
        )
    }

    renderLegalContactsForm = () => {
        if (this.state.selectedPaymentType !== 'payment_invoice') {
            return null
        }

        const user = this.state.user

        return (
            <div className="InstantBookingContactsScreen-submitForm-invoiceFields">
                <div className="InstantBookingContactsScreen-submitForm-info">
                    Так как вы выбрали способ оплаты безналичным расчетом, то вам нужно указать
                    данные по форме ниже:
                </div>
                <div className="InstantBookingContactsScreen-submitForm-largeField">
                    <this.Control
                        type="text"
                        attribute={user.legal_name}
                        name="legal_name"
                        required
                        placeholder="ООО “Образец” / ИП Васильев / Иванов Иван Иванович"
                        label="Название компании / ИП / ФИО"/>
                </div>
                <div className="InstantBookingContactsScreen-submitForm-field">
                    <this.Control
                        type="text"
                        attribute={user.inn}
                        name="inn"
                        label="ИНН"/>
                </div>
                <div className="InstantBookingContactsScreen-submitForm-field">
                    <this.Control
                        type="text"
                        attribute={user.kpp}
                        name="kpp"
                        label="КПП"/>
                </div>
                <div className="InstantBookingContactsScreen-submitForm-largeField">
                    <this.Control
                        type="text"
                        attribute={user.address_legal}
                        name="address_legal"
                        placeholder="344090, Ростовская область, г. Ростов-на-Дону, ул. Стабильная 9"
                        label="Юридический адрес"/>
                </div>
                <div className="InstantBookingContactsScreen-submitForm-largeField">
                    <this.Control
                        type="text"
                        required
                        attribute={user.address_real}
                        name="address_real"
                        label="Физический адрес"/>
                </div>
                <div className="InstantBookingContactsScreen-submitForm-field">
                    <this.Control
                        type="text"
                        required
                        attribute={user.contact_person}
                        name="contact_person"
                        placeholder="Иванов Иван Иванович"
                        label="Контактное лицо"/>
                </div>
            </div>
        )
    }

    render() {
        return (
            <section className="InstantBookingContactsScreen">
                {this.state.showRestorePasswordDialog &&
                <RestorePasswordDialog
                    onRestorePasswordComplete={this._onRestorePasswordComplete}
                    onCloseDialog={this._onCloseRestorePasswordDialog}/>
                }

                <div className="InstantBookingContactsScreen-wrapper container">
                    <main className="InstantBookingContactsScreen-content">
                        <form noValidate onSubmit={this._onSubmit} className="InstantBookingContactsScreen-submitForm">
                            <h2>Осталось узнать ваши контакты</h2>
                            <p>Мы отправим вам данные водителя и чек оплаты</p>
                            {this.renderContactsForm()}
                            {this.renderLegalContactsForm()}
                            <ButtonControl
                                type="submit"
                                size="m"
                                isActive
                                className="InstantBookingContactsScreen-submitForm-button">
                                Забронировать транспорт
                            </ButtonControl>
                            <p className="InstantBookingContactsScreen-submitForm-privacy">
                                Нажимая «Забронировать транспорт», вы соглашаетесь с обработкой ваших <a target="_blank"
                                                                                                         href="/privacy_policy">персональных
                                данных</a>, <a target="_blank" href="/condition">правилами сервиса</a> и с <a
                                target="_blank" href="/oferta_merchant">трехсторонней офертой на перевозку груза</a>
                            </p>
                        </form>
                    </main>
                </div>
                <InstantBookingWhy/>
                <InstantBookingHow/>
                <InstantBookingQa/>
            </section>
        )
    }
}

export default InstantBookingContactsScreen



// WEBPACK FOOTER //
// ./client/components/InstantBookingContactsScreen/InstantBookingContactsScreen.js